var map = {
	"./CanvasClear": 9484,
	"./CanvasClear.ts": 9484,
	"./CanvasMove": 9516,
	"./CanvasMove.ts": 9516,
	"./CommandAbstract": 9946,
	"./CommandAbstract.ts": 9946,
	"./ComponentDelete": 7801,
	"./ComponentDelete.ts": 7801,
	"./ComponentDrag": 4864,
	"./ComponentDrag.ts": 4864,
	"./ComponentEnter": 6134,
	"./ComponentEnter.ts": 6134,
	"./ComponentExit": 914,
	"./ComponentExit.ts": 914,
	"./ComponentNext": 5547,
	"./ComponentNext.ts": 5547,
	"./ComponentPrev": 8655,
	"./ComponentPrev.ts": 8655,
	"./ComponentStyleClear": 7640,
	"./ComponentStyleClear.ts": 7640,
	"./CopyComponent": 5837,
	"./CopyComponent.ts": 5837,
	"./ExportTemplate": 6477,
	"./ExportTemplate.ts": 6477,
	"./Fullscreen": 1772,
	"./Fullscreen.ts": 1772,
	"./MoveComponent": 741,
	"./MoveComponent.ts": 741,
	"./OpenAssets": 2924,
	"./OpenAssets.ts": 2924,
	"./OpenBlocks": 3963,
	"./OpenBlocks.ts": 3963,
	"./OpenLayers": 1479,
	"./OpenLayers.ts": 1479,
	"./OpenStyleManager": 3473,
	"./OpenStyleManager.ts": 3473,
	"./OpenTraitManager": 5054,
	"./OpenTraitManager.ts": 5054,
	"./PasteComponent": 6979,
	"./PasteComponent.ts": 6979,
	"./Preview": 4457,
	"./Preview.ts": 4457,
	"./Resize": 5493,
	"./Resize.ts": 5493,
	"./SelectComponent": 9317,
	"./SelectComponent.ts": 9317,
	"./SelectPosition": 1406,
	"./SelectPosition.ts": 1406,
	"./ShowOffset": 9395,
	"./ShowOffset.ts": 9395,
	"./SwitchVisibility": 7285,
	"./SwitchVisibility.ts": 7285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 585;